<template>
  <div>
    <paySettingFrom :idx="idx" :ref="'forms'+idx" :wages-from.sync="wagesFrom" @changeName="changeName"></paySettingFrom>
    <paySettingItem :idx="idx" :item-lists.sync="itemLists" :wages-from="wagesFrom"></paySettingItem>
    <div class="center save-btn-wrap" >
      <el-button type="primary" size="small"  class="save-btn" @click="subWage">保存</el-button>
    </div>
  </div>
</template>

<script>
  import paySettingFrom from "./paySettingFrom"
  import paySettingItem from "./paySettingItem"
  export default {
    name: "wagesSettings",
    components:{paySettingFrom,paySettingItem},
    props:{
      idx:{
        type:Number,
        default:0
      },
      itemLists:{
        type:Array,
        default:function(){
          return []
        }
      },
      wagesFrom:{
        type:Object,
        default:function(){
          return {
            name:"",
            empty:1,
            org:"",
            lang:1,
          }
        }
      }
    },
    data(){
      return{
        name:""
      }
    },
    methods:{
      subWage(){
        this.$refs['forms'+this.idx].submitForm()
      },
      changeName(newName){
        this.$emit("changeName",[newName,this.idx])
      }
    }
  };
</script>

<style scoped>
  .save-btn-wrap{
    background: #fff;
    width: 80.6%;
    height: 30px;
    position: fixed;
    bottom: 0;
  }
.save-btn{
  position: fixed;
  left: 56%;
  transform: translateX(-50%);
  bottom: 4px
}
</style>
